import React, { useCallback, useMemo, useState, useRef, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux';

import { Report, UnidataTable, Modal } from '~/components';
import {
    RadioGroup, Select
} from '~/components/Form';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO, parse } from 'date-fns';
import { SelectComplete } from '~/componentslocal';
import * as Yup from 'yup';
import { number, t, parseDateString } from '~/helpers';
import { TypeFilters } from '~/components';
import * as S from './styles'

import api from '~/services/api';
import { isEmpty, includes, isArray, isUndefined } from 'lodash';
import { recordFiltering } from '~/store/modules/manutConsultCorrecoes/actions';



export default function ConsultarCorrecoes() {


    const [open, setOpen] = useState(true);
    const [grid, setGrid] = useState(false);
    const [query, setQuery] = useState({});
    const [rowQuery, setRowQuery] = useState({
        data_atual: '',
        posto: '',
        tarefa: '',
        period: '',
        status: ''

    })
    const reference = useRef(null);

    const filterRef = useRef(null);
    const modalRef = useRef(null);

    const [post, setPost] = useState('')
    const [dataObjto, setDataObjto] = useState({});

    const dataRedux = useSelector((state) => state.manutConsultCorrecoes);
    const titlePage = useMemo(() => 'MANUTENÇÃO AGENDA', []);


    const [tipoTypeFilters, setTipoTypeFilters] = useState(0)
    const [dataHoraInicial, setDataHoraInicial] = useState('')
    const [dataHoraFinal, setDataHoraFinal] = useState('')




    const handleGetData = useCallback((value) => {
        setTipoTypeFilters(value.tipo)
        if (value.tipo === 1) {
            setDataHoraInicial(value.datahora_inicio)
            setDataHoraFinal(value.datahora_fim)
        } else if (value.tipo == 5) {

            setDataHoraInicial(value.turno_inicio ? value.turno_inicio.turn_datahora_ini : value.data_inicio_turno + ' 00:00:00')
            setDataHoraFinal(value.turno_fim ? value.turno_fim.turn_datahora_fim : value.data_fim_turno + ' 23:59:59')

        } else if (value.tipo == 2) {
            setDataHoraInicial(value.data_inicio + ' 00:00:00')
            setDataHoraFinal(value.data_fim + ' 23:59:59')
        }
        setDataObjto(value);
    }, [filterRef]);

    const schemaDataHora = Yup.object().shape({
        datahora_inicio: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        datahora_fim: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
    });

    const schemaOnlyDataTurno = Yup.object().shape({
        data_inicio_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        data_fim_turno: Yup.date()
            .typeError('Data inválida')
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
        posto: Yup.string().typeError(t('s.geral.validacao.campoobrigatorio')).required(t('s.geral.validacao.campoobrigatorio'))
    });

    const handleValidate = useCallback(async (data) => {
        try {

            if (tipoTypeFilters == 1) {
                await schemaDataHora.validate({ datahora_inicio: dataHoraInicial, datahora_fim: dataHoraFinal }, {
                    abortEarly: false,
                });
            } else if (tipoTypeFilters == 5) {
                await schemaOnlyDataTurno.validate({ data_inicio_turno: dataHoraInicial, data_fim_turno: dataHoraFinal, posto: post.post_cod_posto }, {
                    abortEarly: false,
                });
            }
            filterRef.current.setErrors({})

        } catch (err) {
            console.log(err)
            const form = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    form[error.path] = error.message.replace(`${error.path} `, '');
                });
                filterRef.current.setErrors(form);

            }
            throw err;
        }
    }, [dataObjto, dataHoraInicial, dataHoraFinal, filterRef, tipoTypeFilters, post])

    const headerUnidataTable = useMemo(
        () => [
            {
                id: 'post_desc',
                label: 'Posto',
            },
            {
                id: 'maag_data_inc',
                label: 'Data Inclusão',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
            },
            {
                id: 'maag_data_con',
                label: 'Data Conclusão',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
            },
            {
                id: 'maag_data_cancela',
                label: 'Data Para Cancelamento',
                formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
            },
            {
                id: 'usolusua_nome',
                label: 'Usuário Solicitante',
            },
            {
                id: 'mata_descricao',
                label: 'Tarefa',
            },
            {
                id: 'maag_status_str',
                label: 'Status',
            },
            {
                id: 'maag_obs',
                label: 'Obs',
            },
            {
                id: 'maag_erro',
                label: 'Erro',
            },

        ],
        []
    );

    const handleShowGrid = useCallback((data) => {
        const { post_cod_posto,
            turn_datahora_ini,
            turn_datahora_fim,
            tarefa,
            status } = data


        const dataQuery = {
            wherefield: ['datahorainicial', 'datahorafinal',],
            valuewherefield: [
                turn_datahora_ini,
                turn_datahora_fim,
            ],
            typewherefield: ['MAIOR_IGUAL', 'MENOR_IGUAL',],
        }

        if (status != 't') {
            dataQuery.wherefield.push('MAAG_STATUS')
            dataQuery.valuewherefield.push(status)
            dataQuery.typewherefield.push('EQUALS')
        }

        if (!isUndefined(tarefa)) {
            dataQuery.wherefield.push('MATA_COD_MATA')
            dataQuery.valuewherefield.push(tarefa)
            dataQuery.typewherefield.push('EQUALS')
        }

        if (!isEmpty(post_cod_posto)) {
            dataQuery.wherefield.push('post_cod_posto')
            dataQuery.valuewherefield.push(post_cod_posto)
            dataQuery.typewherefield.push('EQUALS')
        }

        const descStatus = optionsStatus.find((item) => status == item.value)

        setRowQuery({
            data_atual: format(new Date(), 'dd/MM/yyyy'),
            posto: !isEmpty(post_cod_posto) ? data.posto_str : 'Todos',
            tarefa: !isUndefined(tarefa) ? data.mata_descricao : 'Todos',
            period: `${turn_datahora_ini} à ${turn_datahora_fim}`,
            status: status != 't' ? descStatus.label : 'todos'
        })

        setOpen(false)
        setGrid(true)
        setQuery(dataQuery)

    }, [])

    const optionsStatus = [
        { value: "t", label: "TODOS" },
        { value: "C", label: "Concluido" },
        { value: "P", label: "Pendente" },
        { value: "E", label: "Cancelado Auto" },
    ]


    const handleSerializeForm = useCallback((param) => {

        const serializeObject = {
            ...param,
            post_cod_posto: post.post_cod_posto ? post.post_cod_posto : '',
            posto_str: post.post_desc ? post.post_desc : '',
            turn_datahora_ini: dataHoraInicial,
            turn_datahora_fim: dataHoraFinal,
        }

        handleShowGrid(serializeObject)

        return undefined



    }, [dataHoraInicial, dataHoraFinal, post])



    if (grid && !isEmpty(query))
        return (
            <>
                <S.HeaderWrapper>
                    <li>
                        <span>Data Emissão:</span>
                        {rowQuery.data_atual}
                    </li>
                    <li>
                        <span>Período:</span> {rowQuery.period}
                    </li>
                    <li>
                        <span>Posto:</span>
                        {rowQuery.posto}
                    </li>
                    <li>
                        <span>Tarefa:</span>
                        {rowQuery.tarefa}
                    </li>
                    <li>
                        <span>Status:</span>
                        {rowQuery.status}
                    </li>
                </S.HeaderWrapper>
                <UnidataTable
                    fixed
                    header={headerUnidataTable}
                    read={recordFiltering}
                    redux={dataRedux}
                    title={titlePage}
                    query={query}
                    keys={['post_desc']}
                    detach="post_desc"
                    maxHeight="calc(100vh - 36rem)"
                    create={false}
                    update={false}
                    delete={false}
                />


            </>
        );


    return (
        <>
            <Report
                ref={reference}
                open={open}
                onClose={() => setOpen(false)}
                title="MANUTENÇÃO AGENDA"
                relatorio="manutencaocontrole"
                validate={handleValidate}
                initials={{ status: "t" }}
                serialize={(param) => handleSerializeForm(param)}
            >

                <SelectComplete
                    name="posto"
                    title="Posto"
                    label="post_desc"
                    unique="post_cod_posto"
                    url="usuarioposto"
                    getValue={(value) => {
                        setPost(value);
                    }}
                />

                <TypeFilters
                    ref={filterRef}
                    initials={{
                        tipo: 1,
                        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
                        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
                    }}
                    name="filtroData"
                    numberOfYears={9}
                    options={[
                        { label: t('s.geral.filtro.periododatahora'), value: 1 },
                        { label: t('s.geral.filtro.turno'), value: 5 },
                    ]}
                    onCallback={handleGetData}
                    initialURL="/turno/getturnosinicio"
                    finalURL="/turno/getturnosfim"
                    code={post.post_cod_posto}
                />

                <SelectComplete
                    name="tarefa"
                    title="Tarefa"
                    label="mata_descricao"
                    unique="mata_cod_mata"
                    url="manutencaocontrole/getmanutencaotarefa"
                    hiddens={[{ name: 'mata_descricao' }]}

                />

                <Select
                    name="status"
                    label="Status"
                    options={optionsStatus}
                />

                <RadioGroup
                    name="tipo"
                    label="Formato"
                    options={[
                        { label: 'Tela', value: 'tela' }]
                    }
                    defaultValue="tela"
                    serialize={(value) => value}
                    row
                />

            </Report>
        </>

    )
}
